/** @type {import('zudoku').ZudokuConfig} */
const config = {
  site: {
    showPoweredBy: false,
    url: process.env.ZUDOKU_PUBLIC_SITE_URL || "http://localhost:3000",
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.png" },
      alt: "Munai",
      width: "130px",
      href: "/introduction",
    },
    title: "Documentação Munai",
    description: "Plataforma Munai — documentação técnica e API reference.",
    footer: {
      copyright: "© Munai 2025. Todos os direitos reservados.",
    },
  },

  metadata: {
    favicon: "/favicon.ico"
  },
  docs: {
    defaultOptions: {
      copyPage: false
    }
  },
  theme: {
    defaultMode: "light",
    disableSwitch: true,
    darkMode: false,
  },

  navigation: [
    {
      type: "category",
      label: "Documentação",
      items: [
        {
          type: "category",
          label: "Introdução",
          icon: "sparkles",
          items: [
            "/introduction",
          ],
        },
        {
          type: "category",
          label: "Autenticação",
          icon: "sparkles",
          items: [
            "/authenticator",
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "AUTH",
                color: "purple",
              },
              label: "Referência da Autenticação",
              to: "/autenticacao",
            },
          ],
        }, {
          type: "category",
          label: "Guia Integração - API",
          icon: "sparkles",
          items: [
            "/inti",
            "/guide",
            {
              type: "link",
              icon: "folder-cog",
              label: "Referências entre recursos",
              to: "/refs",
            },
            {
              type: "link",
              icon: "folder-cog",
              label: "Listas de códigos de sistema",
              to: "/codes",
            },
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "API",
                color: "purple",
              },
              label: "Referência da API",
              to: "/api",
            },
          ],
        },
        {
          type: "category",
          label: "Cadastro",
          icon: "sparkles",
          items: [
            "/register-user",
            "/register-prof"
          ],
        },
        {
          type: "category",
          label: "Login",
          icon: "sparkles",
          items: [
            "/login",
            "/change-password",
            "/forgot-password"
          ],
        },
        {
          type: "category",
          label: "Organização",
          icon: "sparkles",
          items: [
            "/organization"
          ],
        },

        {
          type: "category",
          label: "Links Úteis",
          collapsible: false,
          icon: "link",
          items: [
            {
              type: "link",
              icon: "book",
              label: "Portal Munai",
              to: "https://munai.com.br",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/autenticacao",
      label: "Referência da Autenticação",
    },
    {
      type: "link",
      to: "/api",
      label: "Referência da API",
    }
  ],

  // redirects: [{ from: "/", to: "/introduction" }],

  apis: [
    {
      type: "file",
      input: "./apis/autenticacao.yaml",
      path: "/autenticacao",
    },
    {
      type: "file",
      input: "./apis/openapi.yaml",
      path: "/api",
    },
  ],

};

export default config;
